// AI summary motif labels (small tag in the calls list)
export const MOTIF_LABELS = {
  "crevaison": "Crevaison",
  "remplacement": "Remplacement",
  "devis": "Devis",
  "prise de rendez-vous": "Prise de RDV",
  "suivi d'intervention": "Suivi d'intervention",
  "réclamation": "Réclamation",
  "autre": "Autre",
};

export const motifLabel = (m) => MOTIF_LABELS[m] || m;


export const formatDuration = (seconds) => {
  if (!seconds || seconds <= 0) return "—";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m === 0) return `${s}s`;
  return `${m} min ${s.toString().padStart(2, "0")}s`;
};

// Duration rule: billable_seconds for answered calls, "—" otherwise.
export const formatCallDuration = (call) =>
  call && call.status === "answered" ? formatDuration(call.billable_seconds ?? call.duration_seconds) : "—";

// "0:12" / "1:28" clock-style duration for the audio player.
export const formatClock = (seconds) => {
  if (seconds == null || !isFinite(seconds) || seconds < 0) return "0:00";
  const s = Math.floor(seconds);
  return `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, "0")}`;
};

export const initials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const PARIS = "Europe/Paris";
const MOIS = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

const parisParts = (d) => {
  const f = new Intl.DateTimeFormat("fr-FR", {
    timeZone: PARIS, year: "numeric", month: "numeric", day: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false,
  });
  const p = {};
  f.formatToParts(d).forEach((x) => (p[x.type] = x.value));
  return p;
};

// UTC ISO -> Europe/Paris. Today => "14h32", older => "15 juin · 09h24".
export const formatCallTime = (iso) => {
  if (!iso) return "";
  const p = parisParts(new Date(iso));
  const now = parisParts(new Date());
  const hm = `${p.hour}h${p.minute}`;
  if (p.year === now.year && p.month === now.month && p.day === now.day) return hm;
  const mois = MOIS[parseInt(p.month, 10) - 1];
  return `${parseInt(p.day, 10)} ${mois} · ${hm}`;
};
